export const DpiAccountElement = {
	Fund: 'Fund',
	/** Custom element used when splitting grant year from fund for filtering.
	 * Currently applies only to the NC DPI account structure.
	 */
	GrantYear: 'GrantYear',
	Purpose: 'Purpose',
	Program: 'Program',
	Object: 'Object',
	Location: 'Location',
	Department: 'Department',
	Level: 'Level',
	CostCenter: 'CostCenter',
	Project: 'Project',
};
